import { useContext } from "react";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/UnassignCustomerUser.css";
import { CustomerContext } from "../CustomerProvider";
import { thingsBoardMicroserviceUrl } from "../../../../../microservices/thingsboard_microservice";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../../../AppProvider";
const UnassignCustomerUser = () =>{
    const {customerId} = useParams();
    const navigate = useNavigate();
    const {user} = useContext(AppContext);
    const {selectedTenantAdminProfile,unassignCustomerUser,setUnassignCustomerUser} = useContext(CustomerContext);
    const deleteCustomerUserAssignment = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/customers/${customerId}/users/${unassignCustomerUser?.assignment?.customerUserId}/assignments/${unassignCustomerUser?.assignment?.id}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Content-Type':'application/json',
                    'AUthorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok) return;
            throw new Error(`Error code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when deleting customer user assignment',error);
        }
    };
    if(!unassignCustomerUser) return;
    return(
        <div className="tenant-admin-unassign-customer-user-parent-container">
            <div className="tenant-admin-unassign-customer-user-container">
                <div>
                    <h1>Are you sure you want to unassign customer user "{unassignCustomerUser?.profile?.firstName} {unassignCustomerUser?.profile?.lastName}"?</h1>
                    <p>Be careful, after confirmation, this customer user will no longer be associated with the customer.</p>
                </div>
                <div className="buttons-container">
                    <button onClick={() => setUnassignCustomerUser(null)}>No</button>
                    <button onClick={async() =>{
                        await deleteCustomerUserAssignment();
                        setUnassignCustomerUser(null);
                        navigate(`/tenants/customers`)
                    }}>Yes</button>
                </div>
            </div>
        </div>
    );
};
export default UnassignCustomerUser;